<template>
  <section class="OptionCardInsuranceComponent">
    <v-card
      class="mx-auto"
      flat
    >
      <v-list-item>
        <template v-slot:prepend>
          <v-avatar
            color="surface-light"
            size="32"
            class="avatar"
          >
            <img
              :src="props.icon"
              class="icon"
              alt=""
            />
          </v-avatar>
        </template>

        <template v-slot:title> {{ props.title }} </template>

        <template v-slot:append>
          <BaseButton
            @click="emit('open-coverage')"
            class="text-none"
            type="transparent"
            variant="text"
            slim
          >
            {{ t('hiring.common.insurance-options.view-detail') }}
          </BaseButton>
        </template>
      </v-list-item>
    </v-card>
  </section>
</template>

<script setup lang="ts">
  import BaseButton from '@/modules/core/components/ui/BaseButton.vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const props = defineProps({
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    button: {
      type: String,
      required: true
    }
  })

  const emit = defineEmits(['open-coverage'])
</script>

<style lang="scss" scoped>
  .OptionCardInsuranceComponent {
    img.icon {
      filter: brightness(10);
    }

    .avatar {
      background-color: $color-primary-light !important;
      color: $color-neutral-00 !important;
      width: $size-48 !important;
      height: $size-48 !important;
      font-size: $font-size-20;
    }

    .v-list-item {
      padding: $spacing-m $spacing-s $spacing-m $spacing-m;
    }

    :deep(.v-list-item-title) {
      text-wrap: balance;
      color: $color-neutral-dark;
      font-size: $font-size-l;
    }

    :deep(.v-card) {
      border: 1px $color-neutral-light solid;
      overflow: visible;
    }
  }
</style>
